import React, { useState, useEffect } from 'react';
import { collection, getDocs, addDoc, updateDoc, doc, deleteDoc, query, where } from 'firebase/firestore';
import { db } from '../../services/firebase';
import HRCampusSelector from "../../components/HRCampusSelector";
import { getCurrentUser } from "../../auth";

const PayrollDashboard = () => {
  const [selectedCampus, setSelectedCampus] = useState(() => {
    try { return localStorage.getItem("payroll_last_campus") || "bulacan"; } catch { return "bulacan"; }
  });
  const [payrollData, setPayrollData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPeriod, setSelectedPeriod] = useState(() => {
    try { return localStorage.getItem("payroll_last_period") || ''; } catch { return ''; }
  });
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    employeeName: '',
    basicPay: '',
    overtime: '',
    substitution: '',
    substitutionCount: '',
    absences: '',
    sss: '',
    philhealth: '',
    pagIbig: '',
    bir: '',
    booksMisc: '',
    contri: '',
    coop: '',
    uniform: '',
    cashAdvance: '',
    payPeriod: '',
  });
  const [editId, setEditId] = useState(null);
  const [periods, setPeriods] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [previewRecords, setPreviewRecords] = useState([]);

  useEffect(() => {
    const dim = (yy, mm) => new Date(yy, mm + 1, 0).getDate();
    function genPeriods(count) {
      const out = [];
      const now = new Date();
      let y = now.getFullYear();
      let m = now.getMonth();
      let day = now.getDate();
      let startDay = day <= 15 ? 1 : 16;
      for (let i = 0; i < count; i++) {
        const start = new Date(y, m, startDay);
        const endDay = startDay === 1 ? 15 : dim(y, m);
        const monthName = start.toLocaleString(undefined, { month: 'long' });
        const label = `${monthName} ${startDay}\u2013${endDay}, ${y}`;
        const value = `${y}-${String(m + 1).padStart(2, '0')}-${String(startDay).padStart(2, '0')}`;
        out.push({ value, label });
        if (startDay === 16) {
          startDay = 1;
        } else {
          startDay = 16;
          m -= 1;
          if (m < 0) {
            m = 11;
            y -= 1;
          }
        }
      }
      return out;
    }
    const labelFor = (value) => {
      const parts = String(value || "").split("-").map(Number);
      if (parts.length !== 3 || !parts[0] || !parts[1] || !parts[2]) return value;
      const [yy, mm, dd] = parts;
      const monthIndex = mm - 1;
      const endDay = dd === 1 ? 15 : dim(yy, monthIndex);
      const monthName = new Date(yy, monthIndex, 1).toLocaleString(undefined, { month: "long" });
      return `${monthName} ${dd}\u2013${endDay}, ${yy}`;
    };
    const p = genPeriods(36);
    const seen = new Set(p.map(x => x.value));
    if (selectedPeriod && !seen.has(selectedPeriod)) {
      p.unshift({ value: selectedPeriod, label: labelFor(selectedPeriod) });
    }
    setPeriods(p);
    if (!selectedPeriod && p.length) setSelectedPeriod(p[0].value);
  }, []); 

  useEffect(() => {
    if (!Array.isArray(payrollData) || payrollData.length === 0) return;
    setPeriods(prev => {
      const base = Array.isArray(prev) ? prev.slice() : [];
      const seen = new Set(base.map(p => p.value));
      const dim = (yy, mm) => new Date(yy, mm + 1, 0).getDate();
      const labelFor = (value) => {
        const parts = String(value || "").split("-").map(Number);
        if (parts.length !== 3 || !parts[0] || !parts[1] || !parts[2]) return value;
        const [yy, mm, dd] = parts;
        const monthIndex = mm - 1;
        const endDay = dd === 1 ? 15 : dim(yy, monthIndex);
        const monthName = new Date(yy, monthIndex, 1).toLocaleString(undefined, { month: "long" });
        return `${monthName} ${dd}\u2013${endDay}, ${yy}`;
      };
      const vals = Array.from(new Set(payrollData.map(r => String(r.payPeriod || "").trim()).filter(Boolean)));
      vals.sort().reverse();
      for (const v of vals) {
        if (!seen.has(v)) {
          base.push({ value: v, label: labelFor(v) });
          seen.add(v);
        }
      }
      base.sort((a, b) => String(b.value).localeCompare(String(a.value)));
      return base;
    });
  }, [payrollData]);

  useEffect(() => {
    try { if (selectedCampus) localStorage.setItem("payroll_last_campus", selectedCampus); } catch (err) { void 0; }
  }, [selectedCampus]);
  useEffect(() => {
    try { if (selectedPeriod) localStorage.setItem("payroll_last_period", selectedPeriod); } catch (err) { void 0; }
  }, [selectedPeriod]);

  function empLsKey(campus) {
    return `employees_${String(campus || 'gen').toLowerCase()}`;
  }
  function loadLocalEmployees(campus) {
    try {
      const raw = localStorage.getItem(empLsKey(campus));
      return raw ? JSON.parse(raw) : [];
    } catch (err) {
      console.warn("Failed to load local employees");
      return [];
    }
  }
  // Employees map for rates
  const [empRates, setEmpRates] = useState({});
  const [employeesCount, setEmployeesCount] = useState(0);
  function normalizeCampusLabel(x) {
    const s = String(x || "").toLowerCase();
    if (s.includes("gapan")) return "gapan";
    if (s.includes("bulacan")) return "bulacan";
    return s;
  }
  const currentUser = getCurrentUser();
  const roleStr = String(currentUser?.role || "").toLowerCase();
  const rolesArr = Array.isArray(currentUser?.roles) ? currentUser.roles.map(r => String(r).toLowerCase()) : [];
  const hasRole = (r) => roleStr === r || rolesArr.includes(r);
  const isExec = hasRole("admin") || hasRole("superadmin") || hasRole("vicepresident") || hasRole("vp") || hasRole("board") || hasRole("bot") || String(currentUser?.campus || "").toLowerCase() === "all";
  const canReadAllPayroll = isExec || hasRole("finance");
  const [periodJump, setPeriodJump] = useState("");
  useEffect(() => {
    if (canReadAllPayroll && selectedCampus !== "") {
      setSelectedCampus("");
    }
  }, [canReadAllPayroll]); 
  useEffect(() => {
    (async () => {
      try {
        const snap = await getDocs(collection(db, 'employees'));
        let list = snap.docs.map(d => ({ id: d.id, ...d.data() }));
        if (!isExec || selectedCampus) {
          const sc = normalizeCampusLabel(selectedCampus);
          list = list.filter(e => normalizeCampusLabel(e.campus) === sc);
        }
        const map = {};
        for (const e of list) {
          map[String(e.name || "").trim().toLowerCase()] = {
            overtimeRate: Number(e.overtimeRate || 0),
            substitutionRate: Number(e.substitutionRate || 0),
            sss: Number(e.sss || 0),
            philhealth: Number(e.philhealth || 0),
            pagibig: Number(e.pagibig || 0),
            tax: Number(e.tax || 0)
          };
        }
        setEmpRates(map);
        setEmployeesCount(list.length);
      } catch (err) {
        let list = loadLocalEmployees(selectedCampus);
        if (!isExec || selectedCampus) {
          const sc = normalizeCampusLabel(selectedCampus);
          list = list.filter(e => normalizeCampusLabel(e.campus) === sc);
        }
        const map = {};
        for (const e of list) {
          map[String(e.name || "").trim().toLowerCase()] = {
            overtimeRate: Number(e.overtimeRate || 0),
            substitutionRate: Number(e.substitutionRate || 0),
            sss: Number(e.sss || 0),
            philhealth: Number(e.philhealth || 0),
            pagibig: Number(e.pagibig || 0),
            tax: Number(e.tax || 0)
          };
        }
        setEmpRates(map);
        setEmployeesCount(list.length);
      }
    })();
  }, [selectedCampus, isExec]);
  function payrollLsKey(campus) {
    return `payroll_${String(campus || 'gen').toLowerCase()}`;
  }
  function loadLocalPayroll(campus) {
    try {
      const raw = localStorage.getItem(payrollLsKey(campus));
      return raw ? JSON.parse(raw) : [];
    } catch (err) {
      console.warn("Failed to load local payroll");
      return [];
    }
  }
  function saveLocalPayroll(campus, list) {
    try {
      localStorage.setItem(payrollLsKey(campus), JSON.stringify(list));
    } catch (err) {
      console.warn("Failed to save payroll locally");
    }
  }

  // Deduplicate helpers
  function normStr(s) {
    return String(s || "").trim().toLowerCase().replace(/\s+/g, " ");
  }
  function keyOf(rec) {
    return `${normStr(rec.employeeName)}|${String(rec.payPeriod || "")}|${normStr(rec.campus || selectedCampus)}`;
    }
  function dedupList(list) {
    const map = {};
    for (const rec of list) {
      const k = keyOf(rec);
      const prev = map[k];
      if (!prev) {
        map[k] = rec;
      } else {
        // Prefer non-local (Firestore) ids over local LS-*, otherwise keep the first
        const prevIsLocal = String(prev.id || "").startsWith("LS-");
        const currIsLocal = String(rec.id || "").startsWith("LS-");
        if (prevIsLocal && !currIsLocal) map[k] = rec;
      }
    }
    return Object.values(map);
  }

  async function cleanDuplicates() {
    if (!selectedPeriod) {
      alert("Select a pay period first.");
      return;
    }
    setLoading(true);
    try {
      // Fetch all payroll to inspect
      const payrollCollection = collection(db, 'payroll');
      const payrollSnapshot = await getDocs(payrollCollection);
      const list = payrollSnapshot.docs.map(d => ({ id: d.id, ...d.data() }));
      const subset = list.filter(r => String(r.campus || "").toLowerCase() === String(selectedCampus).toLowerCase()
        && String(r.payPeriod || "") === String(selectedPeriod));
      const seen = {};
      const toDelete = [];
      for (const r of subset) {
        const k = keyOf(r);
        if (!seen[k]) {
          seen[k] = r;
        } else {
          // choose which to keep: prefer non-local id, otherwise first
          const keep = seen[k];
          const keepLocal = String(keep.id || "").startsWith("LS-");
          const currLocal = String(r.id || "").startsWith("LS-");
          if (keepLocal && !currLocal) {
            toDelete.push(keep);
            seen[k] = r;
          } else {
            toDelete.push(r);
          }
        }
      }
      if (toDelete.length && !window.confirm(`Found ${toDelete.length} duplicate record(s) for ${selectedCampus.toUpperCase()} — ${selectedPeriod}. Delete duplicates from Firestore (if permitted)?`)) {
        setLoading(false);
        return;
      }
      // Try delete duplicates from Firestore
      let deleted = 0;
      for (const r of toDelete) {
        try {
          await deleteDoc(doc(db, 'payroll', r.id));
          deleted++;
        } catch (err) {
          console.warn("Delete failed (likely permission), id:", r.id);
        }
      }
      // Also clean local cache for campus
      const local = loadLocalPayroll(selectedCampus);
      const cleanedLocal = dedupList(local).filter(rec => !(String(rec.payPeriod || "") === String(selectedPeriod)));
      const keptDupFree = dedupList(local.filter(rec => String(rec.payPeriod || "") === String(selectedPeriod)));
      const merged = [...cleanedLocal, ...keptDupFree];
      saveLocalPayroll(selectedCampus, merged);

      // Refresh state (dedup on load)
      try {
        const snap = await getDocs(collection(db, 'payroll'));
        const fresh = snap.docs.map(d => ({ id: d.id, ...d.data() }));
        setPayrollData(dedupList(fresh));
      } catch (err) {
        setPayrollData(dedupList(loadLocalPayroll(selectedCampus)));
      }
      setLoading(false);
      alert(`Cleanup done. Deleted ${deleted} duplicate record(s) in Firestore (if permitted) and deduped local cache.`);
    } catch (err) {
      console.warn("Cleanup error", err);
      setLoading(false);
      alert("Cleanup finished with warnings. Some items might require permissions to remove.");
    }
  }

  // Fetch payroll data from Firestore
  useEffect(() => {
    const fetchPayrollData = async () => {
      try {
        const payrollCollection = collection(db, 'payroll');
        let ref = payrollCollection;
        if (canReadAllPayroll) {
          if (selectedCampus) {
            ref = query(payrollCollection, where("campus", "==", normalizeCampusLabel(selectedCampus)));
          }
        } else {
          const myCampus = normalizeCampusLabel(currentUser?.campus);
          ref = query(payrollCollection, where("campus", "==", myCampus));
        }
        const payrollSnapshot = await getDocs(ref);
        const payrollList = payrollSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setPayrollData(dedupList(payrollList));
        setLoading(false);
      } catch (error) {
        const local = loadLocalPayroll(selectedCampus);
        setPayrollData(dedupList(local));
        setLoading(false);
      }
    };
    fetchPayrollData();
  }, [selectedCampus, canReadAllPayroll]);

  async function generateFromEmployees() {
    if (!selectedPeriod) {
      alert("Please select a pay period first.");
      return;
    }
    setLoading(true);
    // Fetch employees (try Firestore, fallback local)
    let employees = [];
    try {
      const empCollection = collection(db, 'employees');
      const empSnapshot = await getDocs(empCollection);
      const empList = empSnapshot.docs.map(d => ({ id: d.id, ...d.data() }));
      if (!isExec || selectedCampus) {
        const sc = normalizeCampusLabel(selectedCampus);
        employees = empList.filter(e => normalizeCampusLabel(e.campus) === sc);
      } else {
        employees = empList;
      }
    } catch (err) {
      let local = loadLocalEmployees(selectedCampus);
      if (!isExec || selectedCampus) {
        const sc = normalizeCampusLabel(selectedCampus);
        local = local.filter(e => normalizeCampusLabel(e.campus) === sc);
      }
      employees = local;
    }
    // Prepare existing keys to avoid duplicates (name + period + campus)
    const existingKey = new Set(
      payrollData.map(p => `${String(p.employeeName || "").trim().toLowerCase()}|${String(p.payPeriod)}|${String(p.campus || selectedCampus).toLowerCase()}`)
    );
    const newRecords = [];
    const computeRecord = (emp) => {
      const monthly = Number(emp.salary || 0);
      const basicPay = Math.round((monthly / 2) * 100) / 100;
      const startDay = Number(String(selectedPeriod || '').split('-')[2] || 0);
      const isFirstCutoff = startDay === 1;
      const halfOrFull = (v) => {
        const n = Number(v || 0);
        return normalizeCampusLabel(selectedCampus) === "gapan" ? n : n / 2;
      };
      const booksMisc = halfOrFull(emp.booksMiscMonthly);
      const coop = halfOrFull(emp.coopMonthly);
      const uniform = halfOrFull(emp.uniformMonthly);
      const cashAdvance = halfOrFull(emp.cashAdvanceMonthly);
      const contri = halfOrFull(emp.contriMonthly);
      const sss = isFirstCutoff ? Number(emp.sss || 0) : 0;
      const philhealth = isFirstCutoff ? Number(emp.philhealth || 0) : 0;
      const pagIbig = !isFirstCutoff ? Number(emp.pagibig || 0) : 0;
      const bir = !isFirstCutoff ? Number(emp.tax || 0) : 0;
      const totalDeduction = sss + philhealth + pagIbig + bir + booksMisc + contri + coop + uniform + cashAdvance;
      const payableBeforeDeduction = basicPay;
      const amountToBePaid = basicPay - totalDeduction;
      return {
        employeeName: emp.name || "",
        basicPay,
        overtime: 0,
        substitution: 0,
        absences: 0,
        sss,
        philhealth,
        pagIbig,
        bir,
        booksMisc,
        contri,
        coop,
        uniform,
        cashAdvance,
        totalDeduction,
        payableBeforeDeduction,
        amountToBePaid,
        payPeriod: selectedPeriod,
        campus: selectedCampus
      };
    };
    for (const emp of employees) {
      const key = `${String(emp.name || "").trim().toLowerCase()}|${selectedPeriod}|${String(selectedCampus).toLowerCase()}`;
      if (existingKey.has(key)) continue;
      const record = computeRecord(emp);
      // Try to save to Firestore, else add locally
      try {
        const payload = {
          ...record
        };
        await addDoc(collection(db, 'payroll'), payload);
      } catch (err) {
        newRecords.push({ ...record, id: `LS-${Date.now()}-${Math.random().toString(36).slice(2,7)}` });
      }
    }
    // If any local records created, merge with local store and state
    if (newRecords.length > 0) {
      const currentLocal = loadLocalPayroll(selectedCampus);
      const mergedLocal = [...currentLocal, ...newRecords];
      saveLocalPayroll(selectedCampus, mergedLocal);
    }
    // Refresh state: try refetch Firestore; fallback to local
    try {
      const payrollCollection = collection(db, 'payroll');
      const payrollSnapshot = await getDocs(payrollCollection);
      const payrollList = payrollSnapshot.docs.map(d => ({ id: d.id, ...d.data() }));
      setPayrollData(dedupList(payrollList));
    } catch (err) {
      setPayrollData(dedupList(loadLocalPayroll(selectedCampus)));
    }
    setLoading(false);
  }

  // Preview generation without writing
  async function previewFromEmployees() {
    if (!selectedPeriod) {
      alert("Please select a pay period first.");
      return;
    }
    setPreviewLoading(true);
    try {
      let employees = [];
      try {
        const empCollection = collection(db, "employees");
        const empSnapshot = await getDocs(empCollection);
        const empList = empSnapshot.docs.map(d => ({ id: d.id, ...d.data() }));
        if (!isExec || selectedCampus) {
          const sc = normalizeCampusLabel(selectedCampus);
          employees = empList.filter(e => normalizeCampusLabel(e.campus) === sc);
        } else {
          employees = empList;
        }
      } catch (err) {
        let local = loadLocalEmployees(selectedCampus);
        if (!isExec || selectedCampus) {
          const sc = normalizeCampusLabel(selectedCampus);
          local = local.filter(e => normalizeCampusLabel(e.campus) === sc);
        }
        employees = local;
      }
      // Derive date range from selectedPeriod
      const [y, m, d] = selectedPeriod.split("-").map(Number);
      const startDate = new Date(y, m - 1, d);
      const endDate = new Date(y, m - 1, d === 1 ? 15 : new Date(y, m, 0).getDate());
      const startStr = startDate.toISOString().slice(0,10);
      const endStr = endDate.toISOString().slice(0,10);
      // Load attendance and aggregate overtime minutes by name for period
      let overtimeByName = {};
      try {
        const attSnap = await getDocs(collection(db, "employees_attendance"));
        const atts = attSnap.docs.map(d => ({ id: d.id, ...d.data() }))
          .filter(a => {
            const ac = normalizeCampusLabel(a.campus);
            if (isExec && !selectedCampus) return true;
            return ac === normalizeCampusLabel(selectedCampus);
          })
          .filter(a => {
            const t = new Date(a.date).getTime();
            return t >= startDate.getTime() && t <= endDate.getTime();
          });
        for (const a of atts) {
          const nm = String(a.employeeName || a.employee || "").trim();
          if (!nm) continue;
          overtimeByName[nm.toLowerCase()] = (overtimeByName[nm.toLowerCase()] || 0) + Number(a.overtimeMinutes || 0);
        }
      } catch (e) { /* ignore */ }
      const existingKey = new Set(
        payrollData.map(p => `${String(p.employeeName || "").trim().toLowerCase()}|${String(p.payPeriod)}|${String(p.campus || selectedCampus).toLowerCase()}`)
      );
      const compute = (emp) => {
        const monthly = Number(emp.salary || 0);
        const basicPay = Math.round((monthly / 2) * 100) / 100;
        const startDay = Number(String(selectedPeriod || '').split('-')[2] || 0);
        const isFirstCutoff = startDay === 1;
        const halfOrFull = (v) => {
          const n = Number(v || 0);
          return selectedCampus === "gapan" ? n : n / 2;
        };
        const booksMisc = halfOrFull(emp.booksMiscMonthly);
        const coop = halfOrFull(emp.coopMonthly);
        const uniform = halfOrFull(emp.uniformMonthly);
        const cashAdvance = halfOrFull(emp.cashAdvanceMonthly);
        const contri = halfOrFull(emp.contriMonthly);
        const sss = isFirstCutoff ? Number(emp.sss || 0) : 0;
        const philhealth = isFirstCutoff ? Number(emp.philhealth || 0) : 0;
        const pagIbig = !isFirstCutoff ? Number(emp.pagibig || 0) : 0;
        const bir = !isFirstCutoff ? Number(emp.tax || 0) : 0;
        const nameKey = String(emp.name || "").trim().toLowerCase();
        const otMinutes = Number(overtimeByName[nameKey] || 0);
        const otHours = otMinutes / 60;
        const otRate = empRates[nameKey]?.overtimeRate || 0;
        const overtime = Math.round((otHours * otRate) * 100) / 100;
        const totalDeduction = sss + philhealth + pagIbig + bir + booksMisc + contri + coop + uniform + cashAdvance;
        const payableBeforeDeduction = basicPay + overtime;
        const amountToBePaid = payableBeforeDeduction - totalDeduction;
        return {
          employeeName: emp.name || "",
          basicPay,
          overtime,
          sss,
          philhealth,
          pagIbig,
          bir,
          booksMisc,
          contri,
          coop,
          uniform,
          cashAdvance,
          totalDeduction,
          payableBeforeDeduction,
          amountToBePaid
        };
      };
      const rows = employees
        .filter(emp => {
          const key = `${String(emp.name || "").trim().toLowerCase()}|${selectedPeriod}|${String(selectedCampus).toLowerCase()}`;
          return !existingKey.has(key);
        })
        .map(emp => compute(emp))
        .sort((a, b) => String(a.employeeName || "").localeCompare(String(b.employeeName || "")));
      setPreviewRecords(rows);
      setPreviewOpen(true);
    } finally {
      setPreviewLoading(false);
    }
  }

  async function generateFromPreview() {
    if (!previewRecords.length) {
      setPreviewOpen(false);
      return;
    }
    setLoading(true);
    try {
      let created = 0;
      for (const rec of previewRecords) {
        try {
          await addDoc(collection(db, "payroll"), {
            ...rec,
            overtime: Number(rec.overtime || 0),
            substitution: 0,
            absences: 0,
            payPeriod: selectedPeriod,
            campus: selectedCampus
          });
          created++;
        } catch (err) {
          const currentLocal = loadLocalPayroll(selectedCampus);
          const localRec = { ...rec, id: `LS-${Date.now()}-${Math.random().toString(36).slice(2,7)}`, payPeriod: selectedPeriod, campus: selectedCampus };
          saveLocalPayroll(selectedCampus, [...currentLocal, localRec]);
          created++;
        }
      }
      // Refresh
      try {
        const payrollCollection = collection(db, "payroll");
        const payrollSnapshot = await getDocs(payrollCollection);
        const payrollList = payrollSnapshot.docs.map(d => ({ id: d.id, ...d.data() }));
        setPayrollData(dedupList(payrollList));
      } catch (err) {
        setPayrollData(dedupList(loadLocalPayroll(selectedCampus)));
      }
      alert(`Generated ${created} payroll record(s) from employees.`);
    } finally {
      setPreviewOpen(false);
      setLoading(false);
    }
  }

  const handleEdit = (record) => {
    setForm({
      employeeName: record.employeeName || '',
      basicPay: record.basicPay || '',
      overtime: record.overtime || '',
      substitution: record.substitution || '',
      substitutionCount: '',
      absences: record.absences || '',
      sss: record.sss || '',
      philhealth: record.philhealth || '',
      pagIbig: record.pagIbig || '',
      bir: record.bir || '',
      booksMisc: record.booksMisc || '',
      contri: record.contri || '',
      coop: record.coop || '',
      uniform: record.uniform || '',
      cashAdvance: record.cashAdvance || '',
      payPeriod: record.payPeriod || '',
    });
    setEditId(record.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Delete this payroll record?')) {
      try {
        await deleteDoc(doc(db, 'payroll', id));
        setPayrollData(payrollData.filter(record => record.id !== id));
        try {
          const local = loadLocalPayroll(selectedCampus).filter(r => r.id !== id);
          saveLocalPayroll(selectedCampus, local);
        } catch (err) {
          console.warn("Failed to sync local payroll after cloud delete");
        }
      } catch (err) {
        const next = loadLocalPayroll(selectedCampus).filter(r => r.id !== id);
        saveLocalPayroll(selectedCampus, next);
        setPayrollData(payrollData.filter(record => record.id !== id));
      }
    }
  };

  // Filter by selected campus and period for display and de-duplicate
  const filtered = payrollData.filter(r => {
    const rc = String(r.campus || "").toLowerCase();
    const sc = String(selectedCampus || "").toLowerCase();
    const rp = String(r.payPeriod || "");
    const sp = String(selectedPeriod || "");
    const campusOk = (isExec && !sc) ? true : rc === sc;
    const periodOk = !sp || rp === sp;
    return campusOk && periodOk;
  });
  const dedupMap = {};
  for (const rec of filtered) {
    const key = keyOf(rec);
    if (!dedupMap[key]) dedupMap[key] = rec;
  }
  function nameSortKey(n) {
    const s = String(n || "").trim();
    if (!s) return "";
    let last = "";
    if (s.includes(",")) {
      last = s.split(",")[0].trim().toLowerCase();
    } else {
      const parts = s.split(/\s+/);
      last = (parts[parts.length - 1] || "").toLowerCase();
    }
    const full = s.replace(/,/g, "").toLowerCase();
    return `${last}|${full}`;
  }
  const viewData = Object.values(dedupMap).sort((a, b) => nameSortKey(a.employeeName).localeCompare(nameSortKey(b.employeeName)));
  function applyStatutorySplitByCutoff(rec) {
    const period = String(rec?.payPeriod || "");
    const startDay = Number(period.split("-")[2] || 0);
    const isFirstCutoff = startDay === 1;
    const empKey = String(rec?.employeeName || "").trim().toLowerCase();
    const emp = empRates[empKey] || {};

    const basicPay = Number(rec.basicPay || 0);
    const overtime = Number(rec.overtime || 0);
    const substitution = Number(rec.substitution || 0);
    const absences = Number(rec.absences || 0);

    const booksMisc = Number(rec.booksMisc || 0);
    const contri = Number(rec.contri || 0);
    const coop = Number(rec.coop || 0);
    const uniform = Number(rec.uniform || 0);
    const cashAdvance = Number(rec.cashAdvance || 0);

    const sssBase = Number(rec.sss || 0) || Number(emp.sss || 0);
    const philBase = Number(rec.philhealth || 0) || Number(emp.philhealth || 0);
    const pagBase = Number(rec.pagIbig || 0) || Number(emp.pagibig || 0);
    const birBase = Number(rec.bir || 0) || Number(emp.tax || 0);

    const sss = isFirstCutoff ? sssBase : 0;
    const philhealth = isFirstCutoff ? philBase : 0;
    const pagIbig = !isFirstCutoff ? pagBase : 0;
    const bir = !isFirstCutoff ? birBase : 0;

    const payableBeforeDeduction = basicPay + overtime + substitution;
    const totalDeduction = absences + sss + philhealth + pagIbig + bir + booksMisc + contri + coop + uniform + cashAdvance;
    const amountToBePaid = payableBeforeDeduction - totalDeduction;

    return {
      ...rec,
      sss,
      philhealth,
      pagIbig,
      bir,
      payableBeforeDeduction,
      totalDeduction,
      amountToBePaid
    };
  }
  const viewDataNormalized = viewData.map(applyStatutorySplitByCutoff);
  const totalPayout = viewDataNormalized.reduce((sum, r) => sum + Number(r.amountToBePaid || 0), 0);
  const avgPayout = viewDataNormalized.length ? Math.round((totalPayout / viewDataNormalized.length) * 100) / 100 : 0;
  const pendingAdjustments = viewDataNormalized.filter(r =>
    Number(r.absences || 0) > 0 ||
    Number(r.overtime || 0) > 0 ||
    Number(r.substitution || 0) > 0
  ).length;

  return (
    <div style={{ flexGrow: 1 }}>
      <div className="container-fluid px-4 py-3">
        <HRCampusSelector selectedCampus={selectedCampus} onChange={setSelectedCampus} allowAll={isExec} />
        {/* ===== Summary Cards ===== */}
        <div className="row mb-4 print-hide">
          <div className="col-md-4">
            <div className="card summary-card h-100 info">
              <div className="card-body">
                <div className="summary-label"><i className="bi bi-people me-2 text-info"></i>Total Employees</div>
                <div className="summary-value">{employeesCount}</div>
                <p className="text-muted mb-0">HR employees in campus</p>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card summary-card h-100 success">
              <div className="card-body">
                <div className="summary-label"><i className="bi bi-check2-circle me-2 text-success"></i>Payrolls Processed</div>
                <div className="summary-value">{viewData.length}</div>
                <p className="text-muted mb-0">This period</p>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card summary-card h-100 primary">
              <div className="card-body">
                <div className="summary-label"><i className="bi bi-calendar-event me-2 text-warning"></i>Current Pay Period</div>
                <div className="summary-value">{(periods.find(p => p.value === selectedPeriod)?.label) || 'N/A'}</div>
                <p className="text-muted mb-0">Select pay period above</p>
              </div>
            </div>
          </div>
        </div>
        {/* ===== Additional Metrics ===== */}
        <div className="row mb-4 print-hide">
          <div className="col-md-4">
            <div className="card summary-card h-100 success">
              <div className="card-body">
                <div className="summary-label"><i className="bi bi-cash-stack me-2 text-success"></i>Total Payouts</div>
                <div className="summary-value">₱{Number(totalPayout).toLocaleString()}</div>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card summary-card h-100 primary">
              <div className="card-body">
                <div className="summary-label"><i className="bi bi-person-fill me-2 text-warning"></i>Average per Employee</div>
                <div className="summary-value">₱{Number(avgPayout).toLocaleString()}</div>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card summary-card h-100 danger">
              <div className="card-body">
                <div className="summary-label"><i className="bi bi-exclamation-triangle me-2 text-danger"></i>Pending Adjustments</div>
                <div className="summary-value">{pendingAdjustments}</div>
              </div>
            </div>
          </div>
        </div>
        {/* ===== Quick Links ===== */}
        <div className="row mb-4 print-hide">
          <div className="col-md-6">
            <div className="card h-100 shadow-sm">
              <div className="card-body">
                <h6 className="fw-bold">Add Payroll Entry</h6>
                <p className="text-muted mb-2">Create a new payroll record for an employee</p>
                <button className="btn btn-outline-primary" onClick={() => setShowForm(true)}>
                  Add Payroll
                </button>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card h-100 shadow-sm">
              <div className="card-body">
                <h6 className="fw-bold">Manage Employees</h6>
                <p className="text-muted mb-2">View and update employee records</p>
                <a className="btn btn-outline-success" href="/hr/employees">Open Employee List</a>
              </div>
            </div>
          </div>
        </div>
        {/* ===== Existing Payroll Dashboard Content ===== */}
        <div className="d-flex justify-content-between align-items-center mb-4 print-hide">
          <h2 className="mb-0">Payroll Dashboard</h2>
          <div className="d-flex gap-2 align-items-center">
            <select 
              className="form-select" 
              value={selectedPeriod} 
              onChange={(e) => setSelectedPeriod(e.target.value)}
            >
              <option value="">Select Pay Period</option>
              {periods.map(p => (
                <option key={p.value} value={p.value}>{p.label}</option>
              ))}
            </select>
            <input
              className="form-control"
              style={{ maxWidth: 180 }}
              placeholder="YYYY-MM-01/16"
              value={periodJump}
              onChange={(e) => setPeriodJump(e.target.value)}
            />
            <button
              className="btn btn-outline-secondary"
              onClick={() => {
                const v = String(periodJump || "").trim();
                if (!/^\d{4}-\d{2}-(01|16)$/.test(v)) {
                  alert("Enter a valid pay period start date (YYYY-MM-01 or YYYY-MM-16).");
                  return;
                }
                const parts = v.split("-").map(Number);
                const yy = parts[0];
                const mm = parts[1] - 1;
                const dd = parts[2];
                const endDay = dd === 1 ? 15 : new Date(yy, mm + 1, 0).getDate();
                const monthName = new Date(yy, mm, 1).toLocaleString(undefined, { month: "long" });
                const label = `${monthName} ${dd}\u2013${endDay}, ${yy}`;
                setPeriods(prev => {
                  const list = Array.isArray(prev) ? prev.slice() : [];
                  if (!list.some(p => p.value === v)) list.unshift({ value: v, label });
                  return list;
                });
                setSelectedPeriod(v);
              }}
              title="Jump to a specific pay period"
            >
              Go
            </button>
            <button className="btn btn-primary" onClick={() => { setForm(f => ({ ...f, payPeriod: selectedPeriod })); setShowForm(true); }}>
              <i className="bi bi-plus-circle me-2"></i>New Payroll Entry
            </button>
            <button className="btn btn-outline-primary" onClick={previewFromEmployees} disabled={!selectedPeriod || previewLoading}>
              <i className="bi bi-eye me-2"></i>Preview From Employees
            </button>
            <button className="btn btn-warning" onClick={generateFromEmployees} disabled={!selectedPeriod}>
              <i className="bi bi-magic me-2"></i>Generate From Employees
            </button>
            <button className="btn btn-outline-danger" onClick={cleanDuplicates} disabled={!selectedPeriod} title="Remove duplicate rows for selected campus and period">
              <i className="bi bi-broom me-2"></i>Clean Duplicates
            </button>
            <a
              className={`btn btn-outline-secondary${!selectedPeriod ? " disabled" : ""}`}
              href={selectedPeriod ? `/print/payroll?period=${encodeURIComponent(selectedPeriod)}&campus=${encodeURIComponent(selectedCampus)}` : "#"}
              onClick={e => { if (!selectedPeriod) e.preventDefault(); }}
            >
              <i className="bi bi-printer me-2"></i>Print Preview
            </a>
            <a
              className={`btn btn-outline-primary${!selectedPeriod ? " disabled" : ""}`}
              href={selectedPeriod ? `/print/payslips?period=${encodeURIComponent(selectedPeriod)}&campus=${encodeURIComponent(selectedCampus)}` : "#"}
              onClick={e => { if (!selectedPeriod) e.preventDefault(); }}
              title="Print 8.5×4 payslips (2 copies per employee)"
            >
              <i className="bi bi-ticket-perforated me-2"></i>Payslips
            </a>
          </div>
        </div>

        {/* ===== Preview Modal ===== */}
        {previewOpen && (
          <div className="position-fixed top-0 start-0 w-100 h-100" style={{ background: "rgba(0,0,0,0.35)", zIndex: 1050 }}>
            <div className="position-absolute top-50 start-50 translate-middle" style={{ width: "min(1000px, 95vw)" }}>
              <div className="card shadow-lg">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h5 className="mb-0">Preview Payroll — {selectedCampus?.toUpperCase()} • {periods.find(p => p.value === selectedPeriod)?.label || selectedPeriod}</h5>
                  <button className="btn btn-sm btn-outline-secondary" onClick={() => setPreviewOpen(false)}>Close</button>
                </div>
                <div className="card-body p-0">
                  <div className="table-responsive" style={{ maxHeight: 420 }}>
                    <table className="table table-sm table-hover mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>Name</th>
                          <th className="text-end">Basic</th>
                          <th className="text-end">SSS</th>
                          <th className="text-end">PhilHealth</th>
                          <th className="text-end">Pag‑IBIG</th>
                          <th className="text-end">BIR</th>
                          <th className="text-end">Books/Misc</th>
                          <th className="text-end">Contri</th>
                          <th className="text-end">COOP</th>
                          <th className="text-end">Uniform</th>
                          <th className="text-end">Cash Adv</th>
                          <th className="text-end">Total Deduct</th>
                          <th className="text-end">Net Pay</th>
                        </tr>
                      </thead>
                      <tbody>
                        {previewRecords.length === 0 && (
                          <tr><td colSpan="13" className="text-center text-muted">No employees to generate. They may already have records for this period.</td></tr>
                        )}
                        {previewRecords.map((r, i) => (
                          <tr key={i}>
                            <td>{r.employeeName}</td>
                            <td className="text-end">₱{Number(r.payableBeforeDeduction || r.basicPay || 0).toLocaleString()}</td>
                            <td className="text-end">₱{Number(r.sss || 0).toLocaleString()}</td>
                            <td className="text-end">₱{Number(r.philhealth || 0).toLocaleString()}</td>
                            <td className="text-end">₱{Number(r.pagIbig || 0).toLocaleString()}</td>
                            <td className="text-end">₱{Number(r.bir || 0).toLocaleString()}</td>
                            <td className="text-end">₱{Number(r.booksMisc || 0).toLocaleString()}</td>
                            <td className="text-end">₱{Number(r.contri || 0).toLocaleString()}</td>
                            <td className="text-end">₱{Number(r.coop || 0).toLocaleString()}</td>
                            <td className="text-end">₱{Number(r.uniform || 0).toLocaleString()}</td>
                            <td className="text-end">₱{Number(r.cashAdvance || 0).toLocaleString()}</td>
                            <td className="text-end">₱{Number(r.totalDeduction || 0).toLocaleString()}</td>
                            <td className="text-end fw-bold">₱{Number(r.amountToBePaid || 0).toLocaleString()}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="card-footer d-flex justify-content-between">
                  <div>
                    <strong>{previewRecords.length}</strong> employee(s) to generate • Total payout: <strong>₱{previewRecords.reduce((s,r)=>s+Number(r.amountToBePaid||0),0).toLocaleString()}</strong>
                    {selectedCampus === "gapan" && <span className="ms-2 text-muted">(Gapan: monthly deductions applied in full)</span>}
                  </div>
                  <div className="d-flex gap-2">
                    <button className="btn btn-outline-secondary" onClick={() => setPreviewOpen(false)}>Cancel</button>
                    <button className="btn btn-primary" disabled={previewRecords.length===0} onClick={generateFromPreview}>
                      Confirm & Generate
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="card shadow-sm">
          <div className="card-body p-0">
            {showForm && (
              <div className="p-4 border-bottom">
                <h5 className="mb-3">Add Payroll Entry</h5>
                <form onSubmit={async (e) => {
                  e.preventDefault();
                  // Calculate deductions and net pay
                  const subRate = empRates[String(form.employeeName || "").trim().toLowerCase()]?.substitutionRate || 0;
                  const substitutionComputed = Number(form.substitution || 0) || (Number(form.substitutionCount || 0) * Number(subRate));
                  const startDay = Number(String(form.payPeriod || '').split('-')[2] || 0);
                  const isFirstCutoff = startDay === 1;
                  const sss = isFirstCutoff ? Number(form.sss || 0) : 0;
                  const philhealth = isFirstCutoff ? Number(form.philhealth || 0) : 0;
                  const pagIbig = !isFirstCutoff ? Number(form.pagIbig || 0) : 0;
                  const bir = !isFirstCutoff ? Number(form.bir || 0) : 0;
                  const totalDeduction = [form.absences, sss, philhealth, pagIbig, bir, form.booksMisc, form.contri, form.coop, form.uniform, form.cashAdvance]
                    .reduce((sum, val) => sum + Number(val || 0), 0);
                  const payableBeforeDeduction = Number(form.basicPay || 0) + Number(form.overtime || 0) + Number(substitutionComputed || 0);
                  const amountToBePaid = payableBeforeDeduction - totalDeduction;
                  try {
                    if (editId) {
                      const isLocalEdit = String(editId).startsWith("LS-");
                      const payload = {
                        ...form,
                        campus: selectedCampus,
                        basicPay: Number(form.basicPay || 0),
                        overtime: Number(form.overtime || 0),
                        substitution: Number(substitutionComputed || 0),
                        absences: Number(form.absences || 0),
                        sss,
                        philhealth,
                        pagIbig,
                        bir,
                        booksMisc: Number(form.booksMisc || 0),
                        contri: Number(form.contri || 0),
                        coop: Number(form.coop || 0),
                        uniform: Number(form.uniform || 0),
                        cashAdvance: Number(form.cashAdvance || 0),
                        totalDeduction,
                        payableBeforeDeduction,
                        amountToBePaid,
                        payPeriod: form.payPeriod,
                      };
                      if (isLocalEdit) {
                        await addDoc(collection(db, 'payroll'), payload);
                        try {
                          const local = loadLocalPayroll(selectedCampus).filter(r => r.id !== editId);
                          saveLocalPayroll(selectedCampus, local);
                        } catch { /* ignore */ }
                      } else {
                        await updateDoc(doc(db, 'payroll', editId), payload);
                      }
                    } else {
                      await addDoc(collection(db, 'payroll'), {
                        ...form,
                        campus: selectedCampus,
                        basicPay: Number(form.basicPay || 0),
                        overtime: Number(form.overtime || 0),
                        substitution: Number(substitutionComputed || 0),
                        absences: Number(form.absences || 0),
                        sss,
                        philhealth,
                        pagIbig,
                        bir,
                        booksMisc: Number(form.booksMisc || 0),
                        contri: Number(form.contri || 0),
                        coop: Number(form.coop || 0),
                        uniform: Number(form.uniform || 0),
                        cashAdvance: Number(form.cashAdvance || 0),
                        totalDeduction,
                        payableBeforeDeduction,
                        amountToBePaid,
                        payPeriod: form.payPeriod,
                      });
                    }
                    setShowForm(false);
                    setEditId(null);
                    setForm({
                      employeeName: '',
                      basicPay: '',
                      overtime: '',
                      substitution: '',
                      substitutionCount: '',
                      absences: '',
                      sss: '',
                      philhealth: '',
                      pagIbig: '',
                      bir: '',
                      booksMisc: '',
                      contri: '',
                      coop: '',
                      uniform: '',
                      cashAdvance: '',
                      payPeriod: '',
                    });
                    setLoading(true);
                    // Refetch payroll data
                    const payrollCollection = collection(db, 'payroll');
                    const payrollSnapshot = await getDocs(payrollCollection);
                    const payrollList = payrollSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                    setPayrollData(payrollList);
                    setLoading(false);
                  } catch (error) {
                    alert('Error saving payroll entry: ' + error.message);
                  }
                }}>
                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label">Employee Name</label>
                      <input type="text" className="form-control" required value={form.employeeName} onChange={e => setForm({ ...form, employeeName: e.target.value })} />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Basic Pay (Bi-Monthly)</label>
                      <input type="number" className="form-control" required value={form.basicPay} onChange={e => setForm({ ...form, basicPay: e.target.value })} />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Overtime</label>
                      <input type="number" className="form-control" value={form.overtime} onChange={e => setForm({ ...form, overtime: e.target.value })} />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Substitution</label>
                      <input type="number" className="form-control" value={form.substitution} onChange={e => setForm({ ...form, substitution: e.target.value })} />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Substitution Count</label>
                      <input type="number" className="form-control" value={form.substitutionCount} onChange={e => setForm({ ...form, substitutionCount: e.target.value })} />
                      <div className="small text-muted mt-1">Rate: ₱{empRates[String(form.employeeName || "").trim().toLowerCase()]?.substitutionRate || 0}</div>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Absences/Undertime</label>
                      <input type="number" className="form-control" value={form.absences} onChange={e => setForm({ ...form, absences: e.target.value })} />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">SSS</label>
                      <input type="number" className="form-control" value={form.sss} onChange={e => setForm({ ...form, sss: e.target.value })} />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">PhilHealth</label>
                      <input type="number" className="form-control" value={form.philhealth} onChange={e => setForm({ ...form, philhealth: e.target.value })} />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">PAG-IBIG</label>
                      <input type="number" className="form-control" value={form.pagIbig} onChange={e => setForm({ ...form, pagIbig: e.target.value })} />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">BIR</label>
                      <input type="number" className="form-control" value={form.bir} onChange={e => setForm({ ...form, bir: e.target.value })} />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Books & Misc.</label>
                      <input type="number" className="form-control" value={form.booksMisc} onChange={e => setForm({ ...form, booksMisc: e.target.value })} />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Contri</label>
                      <input type="number" className="form-control" value={form.contri} onChange={e => setForm({ ...form, contri: e.target.value })} />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">COOP</label>
                      <input type="number" className="form-control" value={form.coop} onChange={e => setForm({ ...form, coop: e.target.value })} />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Uniform</label>
                      <input type="number" className="form-control" value={form.uniform} onChange={e => setForm({ ...form, uniform: e.target.value })} />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Cash Advance</label>
                      <input type="number" className="form-control" value={form.cashAdvance} onChange={e => setForm({ ...form, cashAdvance: e.target.value })} />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Pay Period</label>
                      <select className="form-select" required value={form.payPeriod} onChange={e => setForm({ ...form, payPeriod: e.target.value })}>
                        <option value="">Select Pay Period</option>
                        {periods.map(p => (
                          <option key={p.value} value={p.value}>{p.label}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="mt-3 d-flex gap-2">
                    <button type="submit" className="btn btn-success">Save Payroll Entry</button>
                    <button type="button" className="btn btn-secondary" onClick={() => setShowForm(false)}>Cancel</button>
                  </div>
                </form>
              </div>
            )}
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0">
                <thead className="bg-light">
                  <tr>
                    <th>Employee Name</th>
                    <th>Basic Pay (Bi-Monthly)</th>
                    <th>Overtime</th>
                    <th>Substitution</th>
                    <th>Absences/Undertime</th>
                    <th>SSS</th>
                    <th>PhilHealth</th>
                    <th>PAG-IBIG</th>
                    <th>BIR</th>
                    <th>Books & Misc.</th>
                    <th>Contri</th>
                    <th>COOP</th>
                    <th>Uniform</th>
                    <th>Cash Advance</th>
                    <th>Total Deduction</th>
                    <th>Payable Before Deduction</th>
                    <th>Amount to be Paid</th>
                    <th>Employee Signature</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="18" className="text-center py-4">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </td>
                    </tr>
                  ) : viewData.length === 0 ? (
                    <tr>
                      <td colSpan="18" className="text-center py-4 text-muted">
                        No payroll records found
                      </td>
                    </tr>
                  ) : (
                    viewDataNormalized.map((record) => (
                      <tr key={record.id}>
                        <td>{record.employeeName}</td>
                        <td>₱{record.basicPay?.toLocaleString() || '0'}</td>
                        <td>₱{record.overtime?.toLocaleString() || '0'}</td>
                        <td>₱{record.substitution?.toLocaleString() || '0'}</td>
                        <td>₱{record.absences?.toLocaleString() || '0'}</td>
                        <td>₱{record.sss?.toLocaleString() || '0'}</td>
                        <td>₱{record.philhealth?.toLocaleString() || '0'}</td>
                        <td>₱{record.pagIbig?.toLocaleString() || '0'}</td>
                        <td>₱{record.bir?.toLocaleString() || '0'}</td>
                        <td>₱{record.booksMisc?.toLocaleString() || '0'}</td>
                        <td>₱{record.contri?.toLocaleString() || '0'}</td>
                        <td>₱{record.coop?.toLocaleString() || '0'}</td>
                        <td>₱{record.uniform?.toLocaleString() || '0'}</td>
                        <td>₱{record.cashAdvance?.toLocaleString() || '0'}</td>
                        <td>₱{record.totalDeduction?.toLocaleString() || '0'}</td>
                        <td>₱{record.payableBeforeDeduction?.toLocaleString() || '0'}</td>
                        <td>₱{record.amountToBePaid?.toLocaleString() || '0'}</td>
                        <td>
                          <div className="d-flex gap-1 screen-only">
                            <button className="btn btn-sm btn-outline-primary" onClick={() => handleEdit(record)}>
                              <i className="bi bi-pencil"></i>
                            </button>
                            <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(record.id)}>
                              <i className="bi bi-trash"></i>
                            </button>
                          </div>
                          <div className="print-only">
                            <div className="signature-line"></div>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            {/* Print signatories */}
            <div className="signature-block print-only">
              <div className="signature-col">
                <div className="signature-line"></div>
                <div className="signature-name">Prepared by: Catalina T. Basa</div>
                <div className="signature-title">Finance Officer</div>
              </div>
              <div className="signature-col">
                <div className="signature-line"></div>
                <div className="signature-name">Approved by: Marie Lyra Lizardo Oaing</div>
                <div className="signature-title">Vice President of the Board of Trustees</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayrollDashboard;
